export default "__VITE_ASSET__d2d29533__"